import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { onTrackAddItem } from './onTrackAddItem';
import { onTrackCartImpression } from './onTrackCartImpression';
import { onTrackCheckout } from './onTrackCheckout';
import { onTrackCheckoutInput } from './onTrackCheckoutInput';
import { onTrackMiniCartButtonClick } from './onTrackMiniCartButtonClick';
import { onTrackOrderCheckoutButtonClick } from './onTrackOrderCheckoutButtonClick';
import { onTrackProductImpression } from './onTrackProductImpression';
import { onTrackRemoveItem } from './onTrackRemoveItem';
import { onTrackUpdateItem } from './onTrackUpdateItem';
import { onTrackGiftCheckoutPopupShow } from './onTrackGiftCheckoutPopupShow';
import { onTrackGiftCheckoutPopupClick } from './onTrackGiftCheckoutPopupClick';
import { onTrackCartError } from './onTrackCartError';
import { onTrackCheckoutNameInput } from './onTrackCheckoutNameInput';
import { onTrackDeliveryChange } from './onTrackDeliveryChange';
import { onTrackPaymentChange } from './onTrackPaymentChange';
import { onTrackCartCodeCreditPointApply } from './onTrackCartCodeCreditPointApply';
import { onTrackCartMyCouponApply } from './onTrackCartMyCouponApply';
import { onTrackCartMyCouponSelect } from './onTrackCartMyCouponSelect';
import { onTrackCartCodeCreditPointEntranceClick } from './onTrackCartCodeCreditPointEntranceClick';
import { onTrackAddVariationGift } from './onTrackAddVariationGift';
import { onTrackRemoveVariationGift } from './onTrackRemoveVariationGift';

export const onTrackEvent = async (trackerType, payload = {}) => {
  switch (trackerType) {
    case ONE_PAGE_STORE_TRACKER_TYPE.AddItem:
      onTrackAddItem(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.UpdateItem:
      onTrackUpdateItem(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.RemoveItem:
      onTrackRemoveItem(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.AddVariationGift:
      onTrackAddVariationGift(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.RemoveVariationGift:
      onTrackRemoveVariationGift(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.MiniCartButtonClick:
      onTrackMiniCartButtonClick(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.OrderCheckoutButtonClick:
      onTrackOrderCheckoutButtonClick(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CartImpression:
      onTrackCartImpression(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CheckoutInput:
      onTrackCheckoutInput(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.Checkout:
      onTrackCheckout(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.ProductImpression:
      onTrackProductImpression(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.GiftCheckoutPopupShow:
      onTrackGiftCheckoutPopupShow(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.GiftCheckoutPopupClick:
      onTrackGiftCheckoutPopupClick(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CartError:
      onTrackCartError(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CheckoutNameInput:
      onTrackCheckoutNameInput();
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.DeliveryChange:
      onTrackDeliveryChange();
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.PaymentChange:
      onTrackPaymentChange();
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.View:
    case ONE_PAGE_STORE_TRACKER_TYPE.ProductClick:
      console.error(`${trackerType} is triggered by shop`);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CartCodeCreditPointEntranceClick:
      onTrackCartCodeCreditPointEntranceClick(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CartCodeCreditPointApply:
      onTrackCartCodeCreditPointApply(payload);
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CartMyCouponApply:
      onTrackCartMyCouponApply();
      break;
    case ONE_PAGE_STORE_TRACKER_TYPE.CartMyCouponSelect:
      onTrackCartMyCouponSelect();
      break;
    default:
      console.error('Invalid tracker type', trackerType);
  }
};
